import { render } from "./dayEndModel.vue?vue&type=template&id=2c456ce7"
import script from "./dayEndModel.vue?vue&type=script&lang=js"
export * from "./dayEndModel.vue?vue&type=script&lang=js"

import "./dayEndModel.vue?vue&type=style&index=0&id=2c456ce7&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__